import { render } from "./KnowledgeLinkPage.vue?vue&type=template&id=3ce93169"
import script from "./KnowledgeLinkPage.vue?vue&type=script&lang=js"
export * from "./KnowledgeLinkPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__